// extracted by mini-css-extract-plugin
module.exports = {"center":"Center_center_2FKm2"};